import React, { useEffect, useState, useRef } from 'react';
import Plot from 'react-plotly.js';
import './CSS/Bootstrap/bootstrap.css';
import './CSS/style.css';
import {toggle_download_button} from './Javascript/General.js';
import { data_extraction, speed_plot, risk_plot, incidents_types, incident_likelihood, gather_source, ReportPlot } from './Javascript/GenerateReport.js';
import * as RO from './Javascript/ReportObjects';
import ZonePlots from './ZonePlots';
import DetailsTable from './DetailsTable';
import RouteIncidents from './RouteIncidents';
import MapComponent from './MapComponent';
import {roundToTwo, activate_button_customise} from './Javascript/CustomiseReport';
import { assignStatusAndWeaponIncident } from './Javascript/IncidentsReport';
import { get_incident_data, get_incident_data_optimised } from './Javascript/AnalyseRoute';
import * as RA from './Javascript/RiskAnalysis';

interface Props {
  route_analysis: RO.AnalysedRoute | null;
  map_ref: any;
}

const RouteAnalysis: React.FC<Props> = ({ route_analysis, map_ref }) => {
  const [is_loading, set_is_loading] = useState(true);
  const [include, setInclude] = useState(false);
  const [are_ids_valid, set_are_ids_valid] = useState(true);
  const [are_classes_valid, set_are_classes_valid] = useState(true);

  const [hideDetailsTable, setHideDetailsTable] = useState(false);
  const [waypointDetailsOnly, setWaypointDetailsOnly] = useState(false);
  const [incidentsParams, setIncidentsParams] = useState<string[]>(["25", "nm", "3"]);

  const [report_data, set_report_data] = useState<RO.report_info | null>(null);
  const [routeIncidentData, setRouteIncidentData] = useState<RO.RouteIncident[]>([]);
  const [routeIncidentTitle, setRouteIncidentTitle] = useState<string | null>(null);
  const [incidentMarkers, setIncidentMarkers] = useState<RO.Location[] | null>(null);
  const container_ids = [""];
  const container_class = ["plots_container"];
  const [mapKey, setMapKey] = useState(Date.now());

  //new? \/
  const [riskAnalysisPlots, setRiskAnalysisPlots] = useState<RO.AllZonePlots[] | null>(null);
  //current \/
  const [speed_plot_data, set_speed_plot_data] = useState<RO.AllZonePlots | null>(null);
  const [risk_plot_data, set_risk_plot_data] = useState<RO.AllZonePlots | null>(null);
  const [incident_plot_data, set_incident_plot_data] = useState<RO.AllZonePlots | null>(null);
  const [incident_likelihood_plot_data, set_incident_likelihood_plot_data] = useState<RO.AllZonePlots | null>(null);

  const call_generate_pdf = async ( dl_type: string) => {
      if (are_ids_valid && are_classes_valid) {
          gather_source(container_ids, container_class, "page_break", map_ref);
          if(dl_type == 'pdf'){
            gather_source(container_ids, container_class, "download_pdf", map_ref);
          }
          else if(dl_type == 'word'){
            gather_source(container_ids, container_class, "download_word", map_ref);
          }
          else if(dl_type == 'excel'){
            gather_source(container_ids, container_class, "download_excel", map_ref);
          }
      }
  };

  const reloadMap = () => {
    window.location.reload();
  };
  const edit_map_image = async () =>{
      const map_edit_window = document.getElementById("map_custom_cont");
      if(map_edit_window){
        map_edit_window.style.visibility = 'visible';
      }
  };
  const isFetching = useRef(false);
  useEffect(() => {
    const fetchData = async () => {
        try {
            if (route_analysis != null && report_data == null && !isFetching.current) {
                isFetching.current = true;
                const res = await data_extraction(route_analysis);
                await set_report_data(res);
                isFetching.current = false;
            }else if(route_analysis != null && report_data != null){
                var plot_data = risk_plot(report_data);
                set_risk_plot_data(plot_data);
                plot_data = speed_plot(report_data);
                set_speed_plot_data(plot_data);
                plot_data = incidents_types(report_data);
                set_incident_plot_data(plot_data);
                var plot_data = incident_likelihood(report_data);
                set_incident_likelihood_plot_data(plot_data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            if(report_data != null){
                set_is_loading(false);
            }
        }
    };
    if(is_loading){
        fetchData();
    }
    }, [route_analysis, report_data]);

    useEffect(() => {
        if(!is_loading){
            var download_btn = document.getElementById("download_pdf_btn") as HTMLButtonElement;
            if(download_btn){
                download_btn.disabled = false;
                download_btn.addEventListener('click', () => call_generate_pdf('pdf'));
            }
        }
    }, [is_loading]);

    useEffect(() => {
        if(container_ids.length > 1 || container_ids[0] != "") {
            if(container_ids.every((id) => document.getElementById(id))){
                set_are_ids_valid(true);
            }
        }
        else{
            set_are_ids_valid(true);
        }
        if(container_class.length > 1 || container_class[0] != "") {
            if(container_class.every((class_name) =>
                     document.getElementsByClassName(class_name).length > 0)){
                set_are_classes_valid(true);
            }
        }
        else{
            set_are_classes_valid(true);
        }

        if (are_ids_valid && are_classes_valid) {
            gather_source(container_ids, container_class, "page_break");
        }
    }, [report_data]);//, is_loading]); //disabled={true}

   const generateIncidentData = async () =>{
        if(include){
            toggle_download_button();
            set_is_loading(true);
            if(report_data != null){
                const res = await get_incident_data_optimised(report_data);
                setRouteIncidentData(await assignStatusAndWeaponIncident(res[0]));
                setRouteIncidentTitle(res[1] + "" + res[2] + " of route in last "+res[3]+" months");
            }
            set_is_loading(false);
            toggle_download_button();
        }
        else{
            setIncidentMarkers(null);
        }
   }
    useEffect(()=>{
        generateIncidentData();
    }, [include]);
    useEffect(()=>{
        if(include) {
            routeIncidentData.forEach((incident) => {
                incident.incident_coordinates.id = incident.row.toString();
             });
            setIncidentMarkers(routeIncidentData.map((incident) => incident.incident_coordinates));
        }
        else {
            setIncidentMarkers(null);
        }
    }, [routeIncidentData]);

  return (
  <div className="route_analysis_cont">
    <div id="top_btn_panel">
        <button type="button" id="download_pdf_btn" disabled> Download PDF </button>
        <button type="button" id="download_word_btn" disabled={is_loading} onClick={() => call_generate_pdf('word')}> Download Word </button>
        <button style={{display:'none'}} type="button" onClick={() => call_generate_pdf('excel')}> Download excel </button>
        <div className="top_menu_item">
            <input type="checkbox" onChange={(event) => {activate_button_customise(event.target);
                setHideDetailsTable(event.target.checked);}} value="toggle_details_table" defaultChecked={hideDetailsTable}/>
            <p>Hide Details Table</p>
        </div>
        <div className="top_menu_item">
            <input type="checkbox" onChange={(event) => {activate_button_customise(event.target);
                setWaypointDetailsOnly(event.target.checked);}} value="waypoint_details_only" defaultChecked={waypointDetailsOnly}/>
            <p>Waypoint Details only</p>
        </div>
        <div className="top_menu_item">
            <input type="checkbox" onChange={(event) => {setInclude(event.target.checked);}}
             value="include_route_incidents" defaultChecked={include}/>
            <p>Include Incidents</p>
        </div>
        <div className="top_menu_item">
            <p>Incidents Radius</p>
            <input id="incidents_in_radius" type="number" defaultValue={Number(incidentsParams[0])} />
            <select id="incidents_radius_metric" defaultValue={incidentsParams[1]}>
                <option value="nm">NM</option>
                <option value="m">M</option>
                <option value="k">K</option>
            </select>
        </div>
        <div className="top_menu_item">
            <p>Incidents Months</p>
            <input id="incidents_in_months" type="number" defaultValue={Number(incidentsParams[2])}/>
        </div>
        <div className="top_menu_item">
            <button type="button" className="button_style" onClick={(event) => generateIncidentData()}
            value="refresh_route_incidents" disabled={!include}>Update Incidents</button>
        </div>
        <div className="top_menu_item">
            <button type="button" className="button_style" onClick={reloadMap}>Reload Report</button>
        </div>
    </div>
  {route_analysis ?  (
  <>
    <div className="report_row">
        <div id="enforce_page1_div1_height">
        <div className="inner_padding">
            <h1 id="report_title">{ route_analysis.route_name ?? 'UNKNOWN'}</h1>
            <div className="left">
                <p className="sub_title">Transit</p>
                <table id="transit_table">
                <tbody>
                    <tr>
                        <td><span className="title">ETD</span> <br /> { route_analysis.etd.replace("T", " ") ?? 'UNKNOWN'}</td>
                        <td><span className="title">ETA</span> <br /> { route_analysis.eta.replace("T", " ") ?? 'UNKNOWN'}</td>
                        <td><span className="title">Hours</span> <br /> { route_analysis.total_hours ?? 'UNKNOWN'}</td>
                    </tr>

                    <tr>
                        <td><span className="title">Max Speed (kn)</span> <br /> { route_analysis.max_speed?.knots ?? route_analysis.max_speed?.kph ?? 'UNKNOWN'}</td>
                        <td><span className="title">Min Speed (kn)</span> <br /> { route_analysis.min_speed?.knots ?? route_analysis.min_speed?.kph ?? 'UNKNOWN'}</td>
                        <td><span className="title">Distance (nm)</span> <br /> { roundToTwo(route_analysis.total_distance?.nauticalMiles) ?? 'UNKNOWN'}</td>
                    </tr>

                    <tr>
                        <td><span className="title">Max Freeboard (m)</span> <br /> { route_analysis.max_freeboard ?? 'UNKNOWN'}</td>
                        <td><span className="title">Min Freeboard (m)</span> <br /> { route_analysis.min_freeboard ?? 'UNKNOWN'}</td>
                    </tr>
                </tbody>
                </table>
            </div>
            <div className="right">
                <p className="sub_title">Vessel</p>
                <table id="vessel_table">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span> <br /> { route_analysis.vessel?.name ?? 'UNKNOWN'}</td>
                        <td><span className="title">IMO</span> <br /> { route_analysis.vessel?.imo ?? 'UNKNOWN'}</td>
                        <td><span className="title">MMSI</span> <br /> { route_analysis.vessel?.mmsi ?? 'UNKNOWN'}</td>
                    </tr>

                    <tr>
                        <td><span className="title">Type</span> <br /> { route_analysis.vessel?.type ?? 'UNKNOWN'}</td>
                        <td><span className="title">AIS Type</span> <br /> { route_analysis.vessel?.ais_type ?? 'UNKNOWN'}</td>
                        <td><span className="title">DWT</span> <br /> { route_analysis.vessel?.dwt ?? 'UNKNOWN'}</td>
                    </tr>

                    <tr>
                        <td><span className="title">Length (m)</span> <br /> { route_analysis.vessel?.length ?? 'UNKNOWN'}</td>
                        <td><span className="title">Breadth (m)</span> <br /> { route_analysis.vessel?.breadth ?? 'UNKNOWN'}</td>
                        <td><span className="title">Flag</span> <br /> { route_analysis.vessel?.flag?.name ?? 'UNKNOWN'}</td>
                    </tr>
                </tbody>
                </table>
            </div>
        </div>
        </div>
    </div>

</>
    ) : (
        <div className="error_report">
            <p>Error in report generation. Please close the window and try again.</p>
            <p>If issues persist, please contact customer support at <a href="mailto:info@maritrace.com">info@maritrace.com</a>.</p>
        </div>
    )}
    {is_loading ? (
        <div className="loading_section_container">
           <div className="loading_section">
               <p>Generating report ...</p><span className="rotating-arrows">&#8635;</span>
           </div>
        </div>
    ) : (
        <>
            <div className="report_row">
                    <div id="enforce_page2_div2_height">
                    <div className="inner_padding clear_both">
                        {report_data != null && map_ref != null && (
                            <div className="left">
                                <MapComponent key={mapKey+String(include)} report_data={report_data} map_ref={map_ref} markers={incidentMarkers} />
                            </div>
                        )}
                        {risk_plot_data && (risk_plot_data as RO.AllZonePlots).plot_name ? (
                            <div className="right">
                                <p className="sub_title">Assessment</p>
                                <div id="assessment_header">
                                    <div style={{marginLeft:0 }} className="left">
                                        <p className="text">Mitigations Applied (whole route or part):</p>
                                        <p id="mitigation_text">{route_analysis?.mitigations?.join(", ")  ?? "UNKNOWN"}</p>
                                    </div>
                                    <div className="right">
                                        <p className="text">Highest Risk on Route:</p>
                                        <div style={{background: route_analysis?.max_risk_color, color: route_analysis?.max_risk_text_color}} id="risk_assessement">
                                            <p id="risk_text"><b>{route_analysis?.max_risk_string ?? "UNKNOWN"}</b></p>
                                        </div>
                                    </div>
                                </div>
                                <p className="sub_title">Risk</p>
                                <div className="convert_to_image plot_type_1">
                                    <Plot data={risk_plot_data.plot_data.data} layout={risk_plot_data.plot_data.layout}
                                    useResizeHandler={true} style={{width: '100%', height: '100%'}}/>
                                </div>
                            </div>
                            ) : (
                            <p>Risk plot failed</p>
                        )}
                    </div>
                    </div>
                </div>
            <div className="report_row"><div className="page_break"></div></div>

            <div className="user_custom_container">
                <button onClick={edit_map_image}>Edit Map</button>
            </div>

            <ReportPlot plotData={incident_plot_data} title={incident_plot_data?.plot_name} errorMessage="Incident plot failed" />

            <ReportPlot plotData={incident_likelihood_plot_data} title="Incident Likelihood" errorMessage="Incident Risk plot failed" />

            <ReportPlot plotData={speed_plot_data} title={speed_plot_data?.plot_name} errorMessage="Speed plot failed" />

            {report_data && (
                <>
                    <ZonePlots plot_data={report_data} />
                    {report_data.route != null  && !hideDetailsTable && <DetailsTable route_details={report_data.route} waypointOnly={waypointDetailsOnly}/>}
                </>
            )}

               <div className="report_row"><div className="page_break"></div></div>
            <div className="report_row"><div className="page_break"></div></div>
            {report_data?.route != null && include && (
                <RouteIncidents route_data={null} parsedIncidents={routeIncidentData} incidentsListTitle={null} />
            )}
        </>
    )}
  </div>
  );
}
export default RouteAnalysis;
/*
    <div className="top_menu_item">
                <p>Incidents Radius</p>
                <input id="incidents_in_radius" type="number" defaultValue={Number(incidentsParams[0])} onChange={(e) => {
                    const newParams = [...incidentsParams]; newParams[0] = e.target.value; setIncidentsParams(newParams);}}/>
                <select id="incidents_radius_metric" onChange={(e) => { const newParams = [...incidentsParams];
                     newParams[1] = e.target.value; setIncidentsParams(newParams);}} defaultValue={incidentsParams[1]}>
                    <option value="nm">NM</option>
                    <option value="m">M</option>
                    <option value="k">K</option>
                </select>
            </div>
            <div className="top_menu_item">
                <p>Incidents Months</p>
                <input id="incidents_in_months" type="number" defaultValue={Number(incidentsParams[2])} onChange={(e) => {
                    const newParams = [...incidentsParams]; newParams[2] = e.target.value; setIncidentsParams(newParams);}}/>
            </div>
*/